import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { SupportSvg } from './svgs';

export const IconSupport: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={SupportSvg} viewBox="0 0 24 24" {...props} />;
};
